module.exports = __webpack_public_path__ + "518b29b6e015b4f052d5a89bc36b1c25.woff2";